import React,{Component} from 'react';
import 'react-dom';
import {Col, Row} from "reactstrap";
import {Card} from "semantic-ui-react";
import PlaceHolder from "../../../components/PlaceHolder/PlaceHolder";
import Cookies from "js-cookie";
import axios_eventtag from "../../../axios/axios_eventtag";
import apiConfig from "../../../axios/axios_api_services";
import * as common from "../../../const/Common/CommonFunc";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";

let date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
class App extends Component{

  state = {
    dashboards:[
      {
        name:"Currently Running Events",count: 0
      },
      {
        name:"Published Events",count: 0
      },
      {
        name:"Un-Published Events",count: 0
      },
      {
        name:"Drafted Events",count: 0
      }
    ]
  };

  componentDidMount() {
    this.getDashBoardData();
  }

  getDashBoardData = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.GET_EVENT_DASHBOARD_DATA({corporateId: corperateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let list = [
            {
              name:"Currently Running Events",count: response.data.content.count_of_current_events
            },
            {
              name:"Published Events",count: response.data.content.count_of_published_events
            },
            {
              name:"Un-Published Events",count: response.data.content.count_of_unpublished_events
            },
            {
              name:"Drafted Events",count: response.data.content.count_of_draft_events
            }
          ];
          this.setState({
            dashboards: list
          });
        }
      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.getDashBoardData();
      }
    })
      .finally(fin => {
        this.props.spinnerHandler(false);
    });
  };

  render() {
    const {dashboards} = this.state;
    return(
      <Row>
        {
          dashboards.length !== 0 ?
            dashboards.map((element, index) => (
              <Col key={index}>
                <Card
                  fluid
                  color={"orange"}
                  link
                  header={element.name}
                  meta={"Number Of All "+element.name}
                  description={element.count}
                  extra={date}

                />
              </Col>
            ))
            : <PlaceHolder data={[1,2]}/>
        }
      </Row>
    );
  }

}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
